module.exports = __webpack_public_path__ + "img/ricon_de_la_finca.9cc49e8b.jpeg";